module.exports = "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\" xmlns=\"http://www.w3.org/2000/svg\"><title>fault</title><g fill-rule=\"evenodd\"><path d=\"M25 44c10.493 0 19-8.507 19-19S35.493 6 25 6 6 14.507 6 25s8.507 19 19 19zm0 6C11.193 50 0 38.807 0 25S11.193 0 25 0s25 11.193 25 25-11.193 25-25 25z\"></path><path d=\"M42.05 12.193l2.12-2.12-4.242-4.244-2.121 2.122L8.379 37.379 6.257 39.5l4.243 4.243 2.121-2.122L42.05 12.193z\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/add-error.svg
// module id = 871
// module chunks = 0